<template>
    <v-card>
        <v-toolbar dark color="primary">
            <v-btn 
                icon 
                dark 
                :disabled="submitLoading" 
                @click="cancel">
                <v-icon large>close</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title>
                <span v-if="editing">Edit Attribute</span>
                <span v-else>Add New Attribute</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-form ref="editForm" v-model="editValid">
            <v-layout class="dialog-content">
                <v-flex xs12 md6 offset-md3 mt-4>
                    <v-layout wrap>                        
                        <v-flex xs12>
                            <v-text-field 
                                box
                                clearable
                                label="Name"
                                v-model="editData.Name" 
                                :rules="[
                                    rules.required, 
                                    rules.maxOneHundredCharacters
                                ]" 
                                counter >
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-autocomplete
                                label="Product Categories"
                                :items="availableCategories"
                                item-value="ProductCategoryID"
                                item-text="ProductCategoryName"
                                v-model="editData.ProductCategories"
                                box 
                                chips 
                                multiple
                                clearable
                                placeholder="Categories (Optional)"
                                >
                            </v-autocomplete>
                        </v-flex>
                        <v-flex xs12>
                            <v-checkbox 
                                label="Mandatory"
                                v-model="editData.Mandatory">
                            </v-checkbox>
                        </v-flex>
                        <v-flex xs12>
                            <v-checkbox 
                                label="Active"
                                v-model="editData.IsActive">
                            </v-checkbox>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-toolbar dark color="primary">
                                <v-toolbar-title>
                                    <span>Attribute Values</span>                                    
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon color="accent" @click="addEditAttributeValue({ })">
                                    <v-icon large>add</v-icon>
                                </v-btn>
                            </v-toolbar>
                        </v-flex>
                        <v-flex xs12>
                            <attribute-value-table :items="editData.AttributeValues" @edit="addEditAttributeValue($event)" ></attribute-value-table>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap class="dialog-action-buttons">
                        <v-flex xs12 sm6>
                            <v-btn 
                                block 
                                color="success" 
                                :disabled="!editValid || editData.AttributeValues.length === 0" 
                                :loading="submitLoading" 
                                @click="submit">
                                <span>Save</span>
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-btn 
                                block 
                                color="error" 
                                :disabled="submitLoading" 
                                @click="cancel">
                                <span>Cancel</span>
                            </v-btn>
                        </v-flex>
                        <v-flex xs12>
                            <v-alert 
                                :value="submitError != null" 
                                outline 
                                type="error">
                                <span>{{ submitError }}</span>
                            </v-alert>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-form>
        <v-dialog 
            :value="showEditAttributeValue"
            max-width="500px" 
            persistent
            >
            <attribute-value-edit 
                v-if="showEditAttributeValue"
                :item="attributeValueEditData"
                :submitError="error"
                @submit="handleAttributeValueSubmit"
                @cancel="handleAttributeValueCancel">
            </attribute-value-edit>
        </v-dialog>
    </v-card>    
</template>

<script>
import AttributeValueTable from "@/components/configuration/attributes/AttributeValueTable.vue";
import AttributeValueEdit from "@/components/configuration/attributes/AttributeValueEdit.vue";

import validationRules from "@/helpers/validationrules";

export default {
    components: {
        AttributeValueTable: AttributeValueTable,
        AttributeValueEdit: AttributeValueEdit
    },
    props: {
        availableCategories: {
            required: true,
            type: Array
        },
        item: {
            required: true,
            type: Object
        },
        submitError: {
            required: false,
            type: String
        },
        submitLoading: {
            required: false,
            type: Boolean
        }
    },
    data(){
        return {
            rules: validationRules.rules,
            editData: {},
            editValid: false,
            showEditAttributeValue: false,
            attributeValueEditData: {},
            index: 0,
            error: null   
        }
    },
    computed: {
        editing(){
            return this.editData.AttributeID != null;
        }
    },
    methods: {
        cancel(){
            this.$emit("cancel");
        },
        submit(){
            this.$emit("submit", this.editData);
        },
        addEditAttributeValue(item) {
            item.index = this.index;
            this.index += 1;

            this.attributeValueEditData = item;
            this.showEditAttributeValue = true;
        },
        handleAttributeValueCancel() {
            this.showEditAttributeValue = false;
            this.error = null;            
        },
        handleAttributeValueSubmit(item) {
            if (this.editData.AttributeValues.filter(a => a.Name.trim() === item.Name.trim() && a.index !== item.index).length > 0) {
                this.error = "Attribute Value with the same name already exists."
                return;
            }
            
            this.error = null;
            this.showEditAttributeValue = false;

            let index = this.editData.AttributeValues.findIndex(a => a.index === item.index);            

            if (index >= 0) {
                this.editData.AttributeValues.splice(index, 1, item);
            } else {
                this.editData.AttributeValues.push(item);
            }
        }
    },
    async created() {
        this.editData = JSON.parse(JSON.stringify(this.item));
    }
}
</script>